// src/utils/meetingMode.js
/**
 * Meeting Mode Utilities
 * Manages meeting mode state with localStorage persistence and URL override
 */

/**
 * Get current meeting mode state
 * Priority: URL param (?lens=meeting) > localStorage
 * @returns {boolean} - true if meeting mode is active
 */
export function getMeetingMode() {
  // Check URL first - it wins for the current session
  const qs = new URLSearchParams(window.location.search);
  if (qs.get('lens') === 'meeting') {
    return true;
  }
  
  // Fall back to localStorage
  return localStorage.getItem('dva_meeting_mode') === 'true';
}

/**
 * Set meeting mode state and broadcast change
 * @param {boolean} val - New meeting mode state
 */
export function setMeetingMode(val) {
  // Persist to localStorage
  localStorage.setItem('dva_meeting_mode', val ? 'true' : 'false');
  
  // Broadcast change event for reactive updates across components
  window.dispatchEvent(
    new CustomEvent('dva:meetingModeChanged', { 
      detail: { val } 
    })
  );
}